import type {
  CoverageItem,
  ListeningRule,
  MediaBrief,
  MediaOutlet,
  SourceAccount,
  TrackedKeyword,
} from '@/client/types/media';

export const MEDIA_ACCOUNTS: SourceAccount[] = [
  {
    id: 'acc_ff_x',
    platform: 'x',
    handle: '@fairful',
    displayName: 'Fairful',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 128_400,
    verified: true,
    region: 'Global',
    topics: ['brand', 'product'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-25T09:00:00Z',
  },
  {
    id: 'acc_ff_ig',
    platform: 'instagram',
    handle: '@fairful',
    displayName: 'Fairful',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 128_400,
    verified: true,
    region: 'Global',
    topics: ['brand', 'product'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-21T15:00:00Z',
  },
  {
    id: 'acc_ff_li',
    platform: 'linkedin',
    handle: 'fairful',
    displayName: 'Fairful',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 42_100,
    verified: true,
    region: 'Global',
    topics: ['b2b', 'hiring'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-24T16:20:00Z',
  },
  {
    id: 'acc_ff_fb',
    platform: 'facebook',
    handle: 'Fairful',
    displayName: 'Fairful',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 54_000,
    verified: true,
    region: 'Global',
    topics: ['brand', 'hosts'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-19T14:00:00Z',
  },
  {
    id: 'acc_ff_yt',
    platform: 'youtube',
    handle: '@Fairful',
    displayName: 'Fairful',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 19_200,
    verified: true,
    region: 'Global',
    topics: ['brand', 'video'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-21T12:00:00Z',
  },
  {
    id: 'acc_creator_ama',
    platform: 'instagram',
    handle: '@ama.travels',
    displayName: 'Ama Travels',
    owned: false,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'partner_influencer',
    tier: 2,
    followers: 89_000,
    region: 'GH',
    topics: ['travel', 'ugc'],
    ownerName: 'Social',
    contactEmail: 'ama.creator@example.com',
    lastCoveredAt: '2026-07-23T11:00:00Z',
    notes: 'Partner influencer · Frequent positive UGC',
  },
  {
    id: 'acc_kwame_tt',
    platform: 'tiktok',
    handle: '@kwame.eats',
    displayName: 'Kwame Eats',
    owned: false,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'partner_influencer',
    tier: 2,
    followers: 240_000,
    region: 'GH',
    topics: ['food', 'ugc'],
    ownerName: 'Social',
    contactEmail: 'kwesi.creator@example.com',
    lastCoveredAt: '2026-07-24T20:15:00Z',
  },
  {
    id: 'acc_ff_tt',
    platform: 'tiktok',
    handle: '@fairful',
    displayName: 'Fairful TikTok',
    owned: true,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'owned',
    tier: 1,
    followers: 92_000,
    region: 'GH',
    topics: ['brand', 'ugc'],
    ownerName: 'Brand',
    lastCoveredAt: '2026-07-22T10:00:00Z',
  },
  {
    id: 'acc_accra_nights',
    platform: 'x',
    handle: '@accra_nights',
    displayName: 'Accra Nights',
    owned: false,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'competitor',
    tier: 2,
    followers: 62_000,
    region: 'GH',
    topics: ['nightlife', 'local'],
    ownerName: 'Comms',
    lastCoveredAt: '2026-07-25T13:40:00Z',
    notes: 'Crisis thread source',
  },
  {
    id: 'acc_accra_expats',
    platform: 'facebook',
    handle: 'Accra Expats',
    displayName: 'Accra Expats Community',
    owned: false,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'competitor',
    tier: 2,
    followers: 18_400,
    region: 'GH',
    topics: ['community'],
    ownerName: 'Comms',
    lastCoveredAt: '2026-07-25T14:05:00Z',
  },
  {
    id: 'acc_dev_seeker',
    platform: 'x',
    handle: '@dev_seeker',
    displayName: 'Kwame D.',
    owned: false,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'competitor',
    tier: 3,
    followers: 210,
    region: 'GH',
    topics: ['hiring'],
    ownerName: 'Insights',
  },
  {
    id: 'acc_competitor',
    platform: 'x',
    handle: '@rivalstay',
    displayName: 'RivalStay',
    owned: false,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'competitor',
    tier: 2,
    followers: 95_000,
    region: 'Global',
    topics: ['competitor'],
    ownerName: 'Insights',
  },
  {
    id: 'acc_competitor_li',
    platform: 'linkedin',
    handle: 'RivalStay',
    displayName: 'RivalStay',
    owned: false,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'competitor',
    tier: 2,
    followers: 95_000,
    region: 'Global',
    topics: ['competitor'],
    ownerName: 'Insights',
    lastCoveredAt: '2026-07-24T18:00:00Z',
  },
];

export const MEDIA_OUTLETS: MediaOutlet[] = [
  {
    id: 'out_techcrunch',
    name: 'TechCrunch',
    medium: 'online_news',
    tier: 1,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'news_outlet',
    region: 'US',
    website: 'https://techcrunch.com',
    beats: ['startups', 'marketplace'],
    ownerName: 'PR',
    contactEmail: 'tips@techcrunch.com',
    pitchEmail: 'tips@techcrunch.com',
    reach: 12_000_000,
    lastCoveredAt: '2026-07-22T08:00:00Z',
  },
  {
    id: 'out_graphic',
    name: 'Daily Graphic',
    medium: 'print',
    tier: 1,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'news_outlet',
    region: 'GH',
    website: 'https://www.graphic.com.gh',
    beats: ['business', 'consumer'],
    ownerName: 'PR',
    pitchEmail: 'news@graphic.com.gh',
    reach: 1_200_000,
    lastCoveredAt: '2026-07-20T06:00:00Z',
  },
  {
    id: 'out_citi',
    name: 'Citi FM / Channel One',
    medium: 'radio',
    tier: 1,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'news_outlet',
    region: 'GH',
    beats: ['morning drive', 'business'],
    ownerName: 'PR',
    pitchEmail: 'news@citifmonline.com',
    reach: 800_000,
    lastCoveredAt: '2026-07-18T07:30:00Z',
  },
  {
    id: 'out_podcast',
    name: 'Founders of Africa Podcast',
    medium: 'podcast',
    tier: 2,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'partner_media',
    region: 'Africa',
    website: 'https://foundersofafrica.com',
    beats: ['founders', 'tech'],
    ownerName: 'PR',
    pitchEmail: 'editorial@foundersofafrica.com',
    reach: 180_000,
    notes: 'Warm relationship — pitch quarterly',
  },
  {
    id: 'out_foa',
    name: 'Founders of Africa',
    medium: 'online_news',
    tier: 2,
    useAsDestination: true,
    useAsListen: true,
    active: true,
    ownership: 'partner_media',
    region: 'AF',
    website: 'https://foundersofafrica.com',
    beats: ['startups', 'africa'],
    ownerName: 'PR',
    pitchEmail: 'editorial@foundersofafrica.com',
    reach: 240_000,
    contactEmail: 'editorial@foundersofafrica.com',
  },
  {
    id: 'out_spam',
    name: 'Listicle Wire',
    medium: 'wire',
    tier: 3,
    useAsDestination: false,
    useAsListen: true,
    active: true,
    ownership: 'news_outlet',
    region: 'Global',
    beats: ['syndication'],
    doNotPitch: true,
    notes: 'Low-quality syndication; archive unless viral',
  },
];

export const MEDIA_RULES: ListeningRule[] = [
  {
    id: 'rule_brand_core',
    name: 'Brand core',
    queryInclude: 'Fairful OR @fairful OR "Fairful app"',
    queryExclude: 'jobs OR hiring OR "glassdoor"',
    channels: ['social', 'traditional'],
    enabled: true,
    alertOnMatch: true,
    alertVolumeSpike: true,
    alertSentimentDrop: true,
    matchCount: 186,
    lastMatchedAt: '2026-07-25T14:10:00Z',
  },
  {
    id: 'rule_launch_summer',
    name: 'Summer launch',
    queryInclude: '"summer stays" OR #FairfulSummer',
    channels: ['social'],
    enabled: true,
    alertOnMatch: true,
    alertVolumeSpike: false,
    alertSentimentDrop: false,
    matchCount: 54,
    lastMatchedAt: '2026-07-25T12:40:00Z',
  },
  {
    id: 'rule_competitor',
    name: 'Competitor: RivalStay',
    queryInclude: 'RivalStay OR @rivalstay',
    channels: ['social', 'traditional'],
    enabled: true,
    alertOnMatch: false,
    alertVolumeSpike: true,
    alertSentimentDrop: false,
    matchCount: 31,
    lastMatchedAt: '2026-07-24T19:00:00Z',
  },
  {
    id: 'rule_crisis',
    name: 'Safety / scam spikes',
    queryInclude: '(Fairful AND (scam OR unsafe OR fraud))',
    channels: ['social'],
    enabled: true,
    alertOnMatch: true,
    alertVolumeSpike: true,
    alertSentimentDrop: true,
    matchCount: 12,
    lastMatchedAt: '2026-07-25T13:55:00Z',
  },
];

export const MEDIA_TRACKED_KEYWORDS: TrackedKeyword[] = [
  {
    id: 'kw_brand',
    label: 'Fairful',
    terms: ['Fairful', '@fairful'],
    matchMode: 'any',
    channels: ['social', 'traditional'],
    enabled: true,
    createdAt: '2026-07-01T00:00:00Z',
    updatedAt: '2026-07-01T00:00:00Z',
  },
  {
    id: 'kw_summer_tag',
    label: '#FairfulSummer',
    terms: ['#FairfulSummer'],
    matchMode: 'any',
    channels: ['social'],
    enabled: true,
    createdAt: '2026-07-10T00:00:00Z',
    updatedAt: '2026-07-10T00:00:00Z',
  },
  {
    id: 'kw_combo_summer',
    label: 'Fairful + #FairfulSummer',
    terms: ['Fairful', '#FairfulSummer'],
    matchMode: 'all',
    channels: ['social'],
    enabled: true,
    createdAt: '2026-07-12T00:00:00Z',
    updatedAt: '2026-07-12T00:00:00Z',
  },
  {
    id: 'kw_crisis',
    label: 'scam / fraud',
    terms: ['scam', 'fraud', 'unsafe'],
    matchMode: 'any',
    channels: ['social', 'traditional'],
    enabled: true,
    createdAt: '2026-07-20T00:00:00Z',
    updatedAt: '2026-07-25T00:00:00Z',
  },
  {
    id: 'kw_ugc_accra',
    label: '#Accra + Fairful',
    terms: ['#Accra', 'Fairful'],
    matchMode: 'all',
    channels: ['social'],
    enabled: true,
    createdAt: '2026-07-22T00:00:00Z',
    updatedAt: '2026-07-22T00:00:00Z',
  },
  {
    id: 'kw_press_guarantee',
    label: 'host guarantee',
    terms: ['host guarantee', 'guarantees'],
    matchMode: 'any',
    channels: ['traditional'],
    enabled: true,
    createdAt: '2026-07-18T00:00:00Z',
    updatedAt: '2026-07-18T00:00:00Z',
  },
  {
    id: 'kw_west_africa',
    label: 'West Africa + Fairful',
    terms: ['West Africa', 'Fairful'],
    matchMode: 'all',
    channels: ['traditional'],
    enabled: true,
    createdAt: '2026-07-18T00:00:00Z',
    updatedAt: '2026-07-22T00:00:00Z',
  },
  {
    id: 'kw_tier1_expansion',
    label: 'expansion / marketplace',
    terms: ['expansion', 'marketplace'],
    matchMode: 'any',
    channels: ['traditional'],
    enabled: true,
    createdAt: '2026-07-15T00:00:00Z',
    updatedAt: '2026-07-15T00:00:00Z',
  },
];

export const MEDIA_ITEMS: CoverageItem[] = [
  {
    id: 'cov_crisis_1',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'earned',
    platform: 'x',
    title: 'Thread claiming booking scam on Fairful',
    summary:
      'Viral thread alleging payment held without confirmation. 2.4k likes in 3h — triage urgently.',
    bodyExcerpt:
      'Avoid @fairful until they fix payouts. Three friends stuck without refunds…',
    url: 'https://x.com/example/status/1',
    publishedAt: '2026-07-25T13:40:00Z',
    capturedAt: '2026-07-25T13:45:00Z',
    author: '@accra_nights',
    language: 'en',
    sentiment: 'negative',
    sentimentConfidence: 0.92,
    status: 'new',
    urgencyScore: 96,
    tags: ['crisis', 'payments'],
    topics: ['trust', 'refunds'],
    matchedRuleIds: ['rule_brand_core', 'rule_crisis'],
    links: [{ type: 'org', id: 'oid_demo_host', label: 'Coastal Stays GH' }],
    metrics: {
      reach: 180_000,
      likes: 2400,
      comments: 410,
      shares: 890,
      replies: 410,
      impressions: 420_000,
      engagementRate: 0.087,
    },
    subject: 'brand',
    sourceIngest: 'webhook',
    social: {
      format: 'thread',
      accountId: 'acc_accra_nights',
      authorHandle: '@accra_nights',
      authorDisplayName: 'Accra Nights',
      authorFollowers: 62_000,
      caption:
        'Avoid @fairful until they fix payouts. Three friends stuck without refunds…\n\n1/ Thread 🧵',
      hashtags: ['ScamAlert'],
      mentions: ['@fairful'],
      mediaTone: 'bg-gradient-to-br from-slate-800 to-slate-950',
      trackedSince: '2026-07-25T13:45:00Z',
      lastEngagementAt: '2026-07-25T15:10:00Z',
    },
  },
  {
    id: 'cov_crisis_2',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'earned',
    platform: 'facebook',
    title: 'Group post echoing scam claims',
    summary: 'Accra expats group resharing the X thread with local anecdotes.',
    url: 'https://facebook.com/groups/example/posts/2',
    publishedAt: '2026-07-25T14:05:00Z',
    capturedAt: '2026-07-25T14:08:00Z',
    author: 'Accra Expats',
    language: 'en',
    sentiment: 'negative',
    sentimentConfidence: 0.88,
    status: 'flagged',
    urgencyScore: 91,
    assigneeName: 'Comms lead',
    internalNote: 'Draft response with Trust & Safety.',
    tags: ['crisis'],
    topics: ['trust'],
    matchedRuleIds: ['rule_crisis'],
    links: [],
    metrics: {
      reach: 42_000,
      likes: 120,
      comments: 67,
      shares: 34,
      impressions: 58_000,
      engagementRate: 0.038,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'text',
      accountId: 'acc_accra_expats',
      authorHandle: 'Accra Expats',
      authorDisplayName: 'Accra Expats Community',
      authorFollowers: 18_400,
      caption:
        'Anyone else seeing issues with Fairful bookings? Sharing this thread from X — please be careful.',
      mentions: ['Fairful'],
      mediaTone: 'bg-gradient-to-br from-blue-100 to-blue-200',
      isRepost: true,
      quotedText: 'Avoid @fairful until they fix payouts…',
      trackedSince: '2026-07-25T14:08:00Z',
      lastEngagementAt: '2026-07-25T15:00:00Z',
    },
  },
  {
    id: 'cov_tc_launch',
    channel: 'traditional',
    kind: 'publication',
    mediaClass: 'earned',
    outletId: 'out_techcrunch',
    outletName: 'TechCrunch',
    title: 'Fairful expands summer stays marketplace across West Africa',
    summary: 'Tier-1 feature on launch cohort and host guarantees.',
    url: 'https://techcrunch.com/example/fairful-summer',
    publishedAt: '2026-07-22T08:00:00Z',
    capturedAt: '2026-07-22T08:30:00Z',
    author: 'Jordan Lee',
    language: 'en',
    sentiment: 'positive',
    sentimentConfidence: 0.85,
    status: 'reviewed',
    urgencyScore: 40,
    assigneeName: 'PR',
    tags: ['launch', 'tier-1'],
    topics: ['expansion', 'marketplace'],
    matchedRuleIds: ['rule_brand_core', 'rule_launch_summer'],
    links: [
      { type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' },
      { type: 'listing', id: 'eid_beach_01', label: 'Labadi Beach Villa' },
    ],
    metrics: { reach: 1_200_000, ave: 48_000, prValue: 62_000 },
    subject: 'brand',
    sourceIngest: 'url',
  },
  {
    id: 'cov_graphic',
    channel: 'traditional',
    kind: 'publication',
    mediaClass: 'earned',
    outletId: 'out_graphic',
    outletName: 'Daily Graphic',
    title: 'Local hosts find new demand via Fairful',
    summary: 'Business page profile of three Accra hosts.',
    publishedAt: '2026-07-20T06:00:00Z',
    capturedAt: '2026-07-20T10:00:00Z',
    author: 'Efua Mensah',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 25,
    tags: ['print', 'hosts'],
    topics: ['hosts'],
    matchedRuleIds: ['rule_brand_core'],
    links: [{ type: 'org', id: 'oid_host_cluster', label: 'Greater Accra Hosts' }],
    metrics: { ave: 12_000, prValue: 9_500 },
    subject: 'brand',
    sourceIngest: 'manual',
  },
  {
    id: 'cov_clip_radio',
    channel: 'traditional',
    kind: 'clip',
    mediaClass: 'earned',
    outletId: 'out_citi',
    outletName: 'Citi FM / Channel One',
    title: 'Morning drive: marketplace tourism segment',
    summary: '4-minute interview with Fairful GH lead on summer travel.',
    publishedAt: '2026-07-18T07:30:00Z',
    capturedAt: '2026-07-18T09:00:00Z',
    author: 'Citi Breakfast',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 20,
    tags: ['radio', 'interview'],
    topics: ['brand'],
    matchedRuleIds: ['rule_brand_core'],
    links: [{ type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' }],
    metrics: { reach: 350_000, prValue: 18_000 },
    subject: 'brand',
    sourceIngest: 'manual',
  },
  {
    id: 'cov_owned_ig',
    channel: 'social',
    kind: 'post',
    mediaClass: 'owned',
    platform: 'instagram',
    title: 'Owned: #FairfulSummer carousel',
    summary: 'Launch creative — 3 stays, CTA to app.',
    url: 'https://instagram.com/p/example',
    publishedAt: '2026-07-21T15:00:00Z',
    capturedAt: '2026-07-21T15:05:00Z',
    author: '@fairful',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 10,
    tags: ['owned', 'launch'],
    topics: ['campaign'],
    matchedRuleIds: ['rule_launch_summer'],
    links: [{ type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' }],
    metrics: {
      reach: 96_000,
      likes: 4200,
      comments: 310,
      shares: 880,
      saves: 1400,
      impressions: 142_000,
      engagementRate: 0.048,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'carousel',
      accountId: 'acc_ff_ig',
      authorHandle: '@fairful',
      authorDisplayName: 'Fairful',
      authorVerified: true,
      authorFollowers: 128_400,
      caption: 'Summer stays are live ☀️ Swipe for Labadi · Cape Coast · Kumasi. Link in bio.',
      hashtags: ['FairfulSummer', 'WestAfricaTravel'],
      mediaLabel: '1 / 3',
      mediaTone: 'bg-gradient-to-br from-amber-300 via-rose-400 to-fuchsia-500',
      location: 'Accra, Ghana',
      trackedSince: '2026-07-21T15:05:00Z',
      lastEngagementAt: '2026-07-24T10:00:00Z',
    },
  },
  {
    id: 'cov_ugc',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'shared',
    platform: 'instagram',
    title: 'UGC reel from @ama.travels',
    summary: 'Stay unboxing + soft brand tag. Strong save rate.',
    url: 'https://instagram.com/reel/example',
    publishedAt: '2026-07-23T11:00:00Z',
    capturedAt: '2026-07-23T11:20:00Z',
    author: '@ama.travels',
    language: 'en',
    sentiment: 'positive',
    status: 'new',
    urgencyScore: 55,
    tags: ['ugc', 'opportunity'],
    topics: ['creators'],
    matchedRuleIds: ['rule_brand_core', 'rule_launch_summer'],
    links: [
      { type: 'listing', id: 'eid_beach_01', label: 'Labadi Beach Villa' },
      { type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' },
    ],
    metrics: {
      reach: 210_000,
      likes: 18_400,
      comments: 920,
      shares: 2100,
      saves: 5600,
      views: 310_000,
      engagementRate: 0.092,
    },
    subject: 'brand',
    sourceIngest: 'webhook',
    social: {
      format: 'reel',
      accountId: 'acc_creator_ama',
      authorHandle: '@ama.travels',
      authorDisplayName: 'Ama Travels',
      authorFollowers: 89_000,
      caption: 'Found this gem on @fairful 🥹 Labadi Beach Villa — save this!',
      hashtags: ['FairfulSummer', 'AccraStays'],
      mentions: ['@fairful'],
      mediaLabel: '0:28',
      mediaTone: 'bg-gradient-to-br from-cyan-400 via-teal-500 to-emerald-700',
      location: 'Labadi Beach',
      trackedSince: '2026-07-23T11:20:00Z',
      lastEngagementAt: '2026-07-25T12:00:00Z',
    },
  },
  {
    id: 'cov_podcast',
    channel: 'traditional',
    kind: 'clip',
    mediaClass: 'earned',
    outletId: 'out_podcast',
    outletName: 'Founders of Africa',
    title: 'Podcast: building trust in marketplace travel',
    summary: 'Episode 142 — CEO interview, 38 minutes.',
    url: 'https://example.com/foa/142',
    publishedAt: '2026-07-15T10:00:00Z',
    capturedAt: '2026-07-16T08:00:00Z',
    author: 'Founders of Africa',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 15,
    tags: ['podcast'],
    topics: ['founders'],
    matchedRuleIds: ['rule_brand_core'],
    links: [],
    metrics: { views: 14_200, prValue: 7_200 },
    subject: 'brand',
    sourceIngest: 'url',
  },
  {
    id: 'cov_noise',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'earned',
    platform: 'x',
    title: 'Job seeker tagging Fairful careers',
    summary: 'Noise — exclude pattern candidate for listening rule.',
    url: 'https://x.com/example/status/9',
    publishedAt: '2026-07-25T09:10:00Z',
    capturedAt: '2026-07-25T09:12:00Z',
    author: '@dev_seeker',
    language: 'en',
    sentiment: 'neutral',
    status: 'new',
    urgencyScore: 8,
    tags: ['noise'],
    topics: ['hiring'],
    matchedRuleIds: ['rule_brand_core'],
    links: [],
    metrics: { reach: 400, likes: 2, impressions: 900, engagementRate: 0.005 },
    subject: 'brand',
    sourceIngest: 'webhook',
    social: {
      format: 'text',
      accountId: 'acc_dev_seeker',
      authorHandle: '@dev_seeker',
      authorDisplayName: 'Kwame D.',
      authorFollowers: 210,
      caption: 'Anyone hiring at @fairful? Open to frontend roles in Accra 🙏',
      mentions: ['@fairful'],
      mediaTone: 'bg-gradient-to-br from-gray-100 to-gray-200',
      trackedSince: '2026-07-25T09:12:00Z',
    },
  },
  {
    id: 'cov_competitor',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'earned',
    platform: 'linkedin',
    title: 'RivalStay announces Ghana expansion',
    summary: 'Competitor signal for SoV — not brand crisis.',
    url: 'https://linkedin.com/posts/example',
    publishedAt: '2026-07-24T18:00:00Z',
    capturedAt: '2026-07-24T18:20:00Z',
    author: 'RivalStay',
    language: 'en',
    sentiment: 'neutral',
    status: 'new',
    urgencyScore: 35,
    tags: ['competitor'],
    topics: ['expansion'],
    matchedRuleIds: ['rule_competitor'],
    links: [],
    metrics: {
      reach: 55_000,
      likes: 640,
      comments: 88,
      shares: 120,
      impressions: 92_000,
      engagementRate: 0.015,
    },
    subject: 'competitor',
    sourceIngest: 'webhook',
    social: {
      format: 'image',
      accountId: 'acc_competitor_li',
      authorHandle: 'RivalStay',
      authorDisplayName: 'RivalStay',
      authorVerified: true,
      authorFollowers: 95_000,
      caption:
        'Excited to announce our Ghana expansion — hosts and travelers, we’re coming for you.',
      hashtags: ['TravelTech', 'Ghana'],
      mediaLabel: 'Image',
      mediaTone: 'bg-gradient-to-br from-indigo-400 to-slate-700',
      trackedSince: '2026-07-24T18:20:00Z',
    },
  },
  {
    id: 'cov_li_owned',
    channel: 'social',
    kind: 'post',
    mediaClass: 'owned',
    platform: 'linkedin',
    title: 'Owned: host guarantee announcement',
    summary: 'B2B post amplifying TC coverage.',
    url: 'https://linkedin.com/posts/fairful/example',
    publishedAt: '2026-07-22T16:00:00Z',
    capturedAt: '2026-07-22T16:05:00Z',
    author: 'Fairful',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 12,
    tags: ['owned', 'b2b'],
    topics: ['trust'],
    matchedRuleIds: [],
    links: [{ type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' }],
    metrics: {
      reach: 28_000,
      likes: 510,
      comments: 44,
      shares: 76,
      impressions: 41_000,
      engagementRate: 0.022,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'text',
      accountId: 'acc_ff_li',
      authorHandle: 'fairful',
      authorDisplayName: 'Fairful',
      authorVerified: true,
      authorFollowers: 42_100,
      caption:
        'Hosts deserve certainty. Our new guarantee covers verified bookings — more in today’s TechCrunch feature.',
      hashtags: ['Marketplace', 'TrustAndSafety'],
      mediaTone: 'bg-gradient-to-br from-sky-100 to-sky-300',
      trackedSince: '2026-07-22T16:05:00Z',
    },
  },
  {
    id: 'cov_tiktok_ugc',
    channel: 'social',
    kind: 'mention',
    mediaClass: 'shared',
    platform: 'tiktok',
    title: 'TikTok: “Hidden Accra stays” stitch',
    summary: 'Creator stitch tagging Fairful — high completion rate.',
    url: 'https://tiktok.com/@example/video/1',
    publishedAt: '2026-07-24T20:15:00Z',
    capturedAt: '2026-07-24T20:40:00Z',
    author: '@kwame.eats',
    language: 'en',
    sentiment: 'positive',
    status: 'new',
    urgencyScore: 48,
    tags: ['ugc', 'tiktok'],
    topics: ['creators', 'discovery'],
    matchedRuleIds: ['rule_brand_core', 'rule_launch_summer'],
    links: [{ type: 'listing', id: 'eid_beach_01', label: 'Labadi Beach Villa' }],
    metrics: {
      reach: 520_000,
      likes: 41_000,
      comments: 2100,
      shares: 8900,
      views: 780_000,
      engagementRate: 0.11,
    },
    subject: 'brand',
    sourceIngest: 'webhook',
    social: {
      format: 'video',
      accountId: 'acc_kwame_tt',
      authorHandle: '@kwame.eats',
      authorDisplayName: 'Kwame Eats',
      authorFollowers: 240_000,
      caption: 'POV you book Accra through Fairful 👀 #FairfulSummer',
      hashtags: ['FairfulSummer', 'Accra', 'BookTok'],
      mentions: ['@fairful'],
      mediaLabel: '0:18',
      mediaTone: 'bg-gradient-to-br from-fuchsia-600 via-rose-500 to-cyan-400',
      trackedSince: '2026-07-24T20:40:00Z',
      lastEngagementAt: '2026-07-25T14:00:00Z',
    },
  },
  {
    id: 'cov_yt_owned',
    channel: 'social',
    kind: 'post',
    mediaClass: 'owned',
    platform: 'youtube',
    title: 'Owned: Summer Stays launch film',
    summary: '90s brand film — tracking CTR to app store.',
    url: 'https://youtube.com/watch?v=example',
    publishedAt: '2026-07-21T12:00:00Z',
    capturedAt: '2026-07-21T12:10:00Z',
    author: 'Fairful',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 18,
    tags: ['owned', 'video'],
    topics: ['campaign'],
    matchedRuleIds: ['rule_launch_summer'],
    links: [{ type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' }],
    metrics: {
      reach: 88_000,
      likes: 3200,
      comments: 240,
      views: 112_000,
      engagementRate: 0.031,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'video',
      accountId: 'acc_ff_yt',
      authorHandle: '@Fairful',
      authorDisplayName: 'Fairful',
      authorVerified: true,
      authorFollowers: 19_200,
      caption: 'Fairful Summer Stays — find your next escape across West Africa.',
      hashtags: ['FairfulSummer'],
      mediaLabel: '1:32',
      mediaTone: 'bg-gradient-to-br from-red-600 to-red-900',
      trackedSince: '2026-07-21T12:10:00Z',
    },
  },
  {
    id: 'cov_fb_owned',
    channel: 'social',
    kind: 'post',
    mediaClass: 'owned',
    platform: 'facebook',
    title: 'Owned: host onboarding tips carousel',
    summary: 'Organic page post for host education.',
    url: 'https://facebook.com/fairful/posts/example',
    publishedAt: '2026-07-19T14:00:00Z',
    capturedAt: '2026-07-19T14:05:00Z',
    author: 'Fairful',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 9,
    tags: ['owned', 'hosts'],
    topics: ['hosts'],
    matchedRuleIds: [],
    links: [],
    metrics: {
      reach: 22_000,
      likes: 380,
      comments: 52,
      shares: 41,
      impressions: 31_000,
      engagementRate: 0.021,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'carousel',
      accountId: 'acc_ff_fb',
      authorHandle: 'Fairful',
      authorDisplayName: 'Fairful',
      authorVerified: true,
      authorFollowers: 54_000,
      caption: 'New host? 5 tips to get your first 10 bookings 🏡',
      hashtags: ['HostTips'],
      mediaLabel: '1 / 5',
      mediaTone: 'bg-gradient-to-br from-blue-400 to-indigo-600',
      trackedSince: '2026-07-19T14:05:00Z',
    },
  },
  {
    id: 'cov_x_owned',
    channel: 'social',
    kind: 'post',
    mediaClass: 'owned',
    platform: 'x',
    title: 'Owned: launch day announcement',
    summary: 'Pinned launch tweet with product link.',
    url: 'https://x.com/fairful/status/launch',
    publishedAt: '2026-07-21T08:00:00Z',
    capturedAt: '2026-07-21T08:02:00Z',
    author: '@fairful',
    language: 'en',
    sentiment: 'positive',
    status: 'reviewed',
    urgencyScore: 14,
    tags: ['owned', 'launch'],
    topics: ['campaign'],
    matchedRuleIds: ['rule_launch_summer'],
    links: [{ type: 'campaign', id: 'camp_summer_26', label: 'Summer Stays 2026' }],
    metrics: {
      reach: 74_000,
      likes: 2100,
      comments: 180,
      shares: 640,
      replies: 180,
      impressions: 198_000,
      engagementRate: 0.029,
    },
    subject: 'brand',
    sourceIngest: 'manual',
    social: {
      format: 'image',
      accountId: 'acc_ff_x',
      authorHandle: '@fairful',
      authorDisplayName: 'Fairful',
      authorVerified: true,
      authorFollowers: 128_400,
      caption: 'Summer Stays are live across West Africa. Book with host guarantees → fairful.app/summer',
      hashtags: ['FairfulSummer'],
      mediaLabel: 'Image',
      mediaTone: 'bg-gradient-to-br from-sky-400 to-blue-700',
      trackedSince: '2026-07-21T08:02:00Z',
    },
  },
  {
    id: 'cov_wire_low',
    channel: 'traditional',
    kind: 'publication',
    mediaClass: 'earned',
    outletId: 'out_spam',
    outletName: 'Listicle Wire',
    title: '10 apps to watch (syndicated blurb)',
    summary: 'Low-tier syndication — candidate to archive.',
    publishedAt: '2026-07-19T12:00:00Z',
    capturedAt: '2026-07-19T14:00:00Z',
    language: 'en',
    sentiment: 'neutral',
    status: 'archived',
    urgencyScore: 5,
    tags: ['low-tier'],
    topics: ['lists'],
    matchedRuleIds: ['rule_brand_core'],
    links: [],
    metrics: { ave: 400 },
    subject: 'brand',
    sourceIngest: 'rss',
  },
];

export const MEDIA_BRIEFS: MediaBrief[] = [
  {
    id: 'brief_week_30',
    title: 'Week 30 media brief',
    periodLabel: 'Jul 14–20, 2026',
    status: 'published',
    itemIds: ['cov_tc_launch', 'cov_graphic', 'cov_clip_radio', 'cov_podcast'],
    createdAt: '2026-07-20T17:00:00Z',
    updatedAt: '2026-07-21T09:00:00Z',
  },
  {
    id: 'brief_crisis',
    title: 'Crisis watch — Jul 25',
    periodLabel: 'Jul 25, 2026',
    status: 'draft',
    itemIds: ['cov_crisis_1', 'cov_crisis_2'],
    createdAt: '2026-07-25T14:20:00Z',
    updatedAt: '2026-07-25T14:20:00Z',
  },
  {
    id: 'brief_summer',
    title: 'Summer Stays clip book',
    periodLabel: 'Campaign to date',
    status: 'draft',
    itemIds: ['cov_tc_launch', 'cov_owned_ig', 'cov_ugc', 'cov_clip_radio'],
    createdAt: '2026-07-23T12:00:00Z',
    updatedAt: '2026-07-24T08:00:00Z',
  },
];

export function formatCompact(n?: number): string {
  if (n == null) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(n);
}

export function sourceLabel(item: CoverageItem): string {
  if (item.outletName) return item.outletName;
  if (item.platform) {
    const map: Record<string, string> = {
      x: 'X',
      instagram: 'Instagram',
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      tiktok: 'TikTok',
      youtube: 'YouTube',
      other: 'Other',
    };
    return map[item.platform] ?? item.platform;
  }
  return '—';
}
